export default __webpack_public_path__ + "static/media/moncf_logo.1c5fae34.png";